import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getTranslation } from 'common/react/utils/translations';
import { playerModalSelector } from 'common/store/modules/player-awards/player-modal/selectors';
import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { useGetBFAwardsSeasonQuery } from 'common/store/modules/api/cfs-api';

export const PlayerModalPhoto = () => {
    const modal = useSelector(playerModalSelector);
    // eslint-disable-next-line no-magic-numbers
    const seasonYear = modal.seasonPid.substr(4, 4);

    const { data } = useGetBFAwardsSeasonQuery(
        {
            seasonPid: modal.seasonPid
        },
        {
            skip: !modal.seasonPid
        }
    );

    const compAbbreviation = PULSE.app.common.match
        .getCompAbbr(data?.seasonId)
        ?.toLowerCase();

    const playerVotesData = useMemo(() => {
        return data?.players?.find(
            (item) => item.player.playerId === modal.playerId
        );
    }, [modal, data]);

    let watermarkPrefix = '';

    if (playerVotesData && playerVotesData.team?.teamId) {
        if (
            PULSE.app.common.team
                .getAFLWSpecificIcons()
                .includes(playerVotesData.team?.teamId)
        ) {
            watermarkPrefix = 'aflw-';
        }
    }

    const teamAbbr = modal?.team?.teamId
        ? PULSE.app.common.team.getTeamAbbr(modal?.team.teamId)
        : '';

    return (
        <div className="player-awards-player-modal__player-headshot-container">
            <div className="player-awards-player-modal__player-headshot-inner-container">
                <div
                    className={`player-awards-player-modal__player-headshot-photo-container ${teamAbbr}`}
                >
                    {teamAbbr ? (
                        <div
                            className="player-awards-player-modal__player-headshot-watermark"
                            style={{
                                backgroundImage: `url('${PULSE.app.environment.watermarksPath}${teamAbbr}-${watermarkPrefix}right-dark.png')`
                            }}
                        ></div>
                    ) : null}

                    <PlayerPhoto
                        className="player-awards-player-modal__photo"
                        photoUrl={
                            playerVotesData?.player.photoURL ||
                            modal?.player?.photoURL
                        }
                        scale="0.5"
                        alt={`${getTranslation('label.stats.headshot.alt')} ${
                            playerVotesData?.player.givenName
                        } ${playerVotesData?.player.surname}`}
                    />
                </div>
            </div>

            {playerVotesData?.winner ? (
                <div className="player-awards-player-modal__player-headshot-ribbon">
                    <span className="player-awards-player-modal__player-headshot-ribbon-text">
                        <span>{seasonYear}</span>{' '}
                        {compAbbreviation === 'aflw'
                            ? getTranslation(
                                  'label.playerAwards.tracker.bestAndFairestMedallist'
                              )
                            : getTranslation(
                                  'label.brownlow.tracker.brownlowMedallist'
                              )}
                    </span>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};
